import { render, staticRenderFns } from "./SelectEditAirplaneType.vue?vue&type=template&id=28dc7894&"
import script from "./SelectEditAirplaneType.vue?vue&type=script&lang=js&"
export * from "./SelectEditAirplaneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AirplaneItem: require('/opt/buildhome/repo/components/global/AirplaneItem.vue').default,Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
